export const CURRENCY_UNIT = "$";

export type UnitPlacement = "prefix" | "suffix";

export const isCurrencyUnit = (unit?: string | null): boolean => unit?.trim() === CURRENCY_UNIT;

export function getUnitPlacement(unit?: string | null): UnitPlacement | null {
  if (!unit || unit === "none") return null;
  return isCurrencyUnit(unit) ? "prefix" : "suffix";
}

export function formatValueWithUnit(value: unknown, unit?: string | null): string {
  const placement = getUnitPlacement(unit);
  if (!placement) return `${value}`;
  if (placement === "suffix") return `${value} ${unit}`;
  const text = `${value}`;
  return text.startsWith("-") ? `-${CURRENCY_UNIT}${text.slice(1)}` : `${CURRENCY_UNIT}${text}`;
}
